module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/card-back@2x_32dfb2.png";